import { Link, useLocation } from 'react-router-dom';

const MainNavMenu = () => {
  return (
    <div className='flex rounded-lg items-center justify-between'>
      <Link to="/map">
        <button type="button" className="font-semibold text-[#1e293b] uppercase bg-[#F8F8F8] hover:bg-[#cbd5e1] rounded-lg text-base px-2 py-2 text-center inline-flex items-center me-2">
        <svg className="w-8 h-8 text-gray-800" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 12h14M5 12l4-4m-4 4 4 4"/>
          </svg> <p className='hidden md:block'>Back</p>
        </button>
      </Link>
    </div>
  );
};

export default MainNavMenu;
